const WhoIsJoining = Object.freeze({
  SOLO: 'solo',
  COUPLE: 'couple',
  FAMILY: 'family',
  GROUP_OF_FRIENDS: 'group_of_friends',
} as const);

export type WhoIsJoining = (typeof WhoIsJoining)[keyof typeof WhoIsJoining];
export const allWhoIsJoining: [WhoIsJoining, ...WhoIsJoining[]] = Object.values(WhoIsJoining) as [
  WhoIsJoining,
  ...WhoIsJoining[],
];

export default WhoIsJoining;
